import CtrlProvedores from './pages/CtrlProvedoresPage.vue'

const routes = [
  {
    path: 'ctrl-provedores',
    name: 'ctrl-provedores',
    component: CtrlProvedores
  }
];

export default routes;